import React from 'react';

export default ({ color }) => (
  <svg width="100%" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 10.5586C0 15.7789 3.79138 20.1197 8.75 21V13.4164H6.125V10.5H8.75V8.16638C8.75 5.54138 10.4414 4.08362 12.8336 4.08362C13.5914 4.08362 14.4086 4.2 15.1664 4.31638V7H13.825C12.5414 7 12.25 7.64137 12.25 8.45862V10.5H15.05L14.5836 13.4164H12.25V21C17.2086 20.1197 21 15.7798 21 10.5586C21 4.75125 16.275 0 10.5 0C4.725 0 0 4.75125 0 10.5586Z" style={{ fill: `var(--social-icon-color, ${color || 'black'})` }} />
  </svg>
);
